import { AppDefinition } from '../../types/apps';

export const ListenAppDefinition: AppDefinition = {
  appId: 'listen-app',
  name: 'Listen',
  version: '1.0.0',
  description: 'Read documents aloud using natural text-to-speech',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'SpeakerHigh',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
  },
  supportedFileTypes: [],
  entityTypes: ['Doc', 'Note', 'File.Document.PDF'],
  component: 'ListenApp',
  requiresProps: false,
  requiresEntity: false,
  features: [
    'Natural text-to-speech using OpenAI',
    'Multiple voice options',
    'Adjustable reading speed',
    'Support for Docs, PDFs, and Notes',
    'Mobile-optimized player interface'
  ],
  actions: {},
  experimental: true,
  hidden: true,
};






